import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import UserMenuTsoPq from '@components/Navbar/UserMenuTsoPq';
import NavigationNodeTsoPq from '@components/NavigationNode/NavigationNodeTsoPq';
import { generateNavbarMenu } from '@constants/navbarMenu';
import { RouteMap } from '@constants/routes';
import HomeIcon from '@mui/icons-material/Home';
import { Box, IconButton } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { useAppSelector } from '@redux/hooks';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { NavigationNodeProps } from 'src/custom-types/NavbarTypes';
import NavbarIcon from './NavbarIconTsoPq';

const StyledToolbar = styled(Toolbar)(() => {
  return { '&.MuiToolbar-root': { display: 'flex', justifyContent: 'space-between', padding: '0' } };
});

const StyledNavBar = styled(AppBar)(() => {
  return {
    borderBottom: `1px solid ${tsoPqTheme.palette.stroke.color_primary_stroke_str_prim_accent}`,
    boxShadow: 'none',
    backgroundColor: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
    padding: `0 ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_48}`,
    height: '',
    '& .MuiToolbar-root': { minHeight: 'auto' },
  };
});

const StyledBox = styled(Box)(() => {
  return {
    display: 'flex',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
    padding: `0 ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24} 0 ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24}`,

    '& .MuiButtonBase-root': {
      '&:hover': {
        background: 'transparent',
      },

      '&:active': {
        outline: 'none',
      },

      '&:focus': {
        outline: 'none',
      },
    },
  };
});

const StyledIconButton = styled(IconButton)(() => {
  return {
    '&.MuiIconButton-root': {
      borderRadius: 0,

      '&:hover': {
        background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_accent,
      },

      '&:active': {
        background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_pressed_lt,
      },
    },
  };
});

const NavbarTsoPq = () => {
  const [accountNavbarMenu, setAccountNavbarMenu] = useState<NavigationNodeProps[] | []>([]);

  const tsoAbbreviation = useAppSelector((state) => state.tsoIdentification.abbreviation);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setAccountNavbarMenu(generateNavbarMenu(tsoAbbreviation));
  }, [tsoAbbreviation]);

  return (
    <StyledNavBar>
      <StyledToolbar>
        <NavbarIcon />
        <StyledBox>
          <StyledIconButton disableRipple data-testid="navbarHomeButton" onClick={() => navigate(RouteMap.HOME_ROUTE)}>
            <HomeIcon />
          </StyledIconButton>

          {accountNavbarMenu.map((node) => (
            <NavigationNodeTsoPq
              key={node.id}
              id={node.id}
              active={RouteMap[node.path as keyof typeof RouteMap] === location.pathname}
              options={node.options}
              label={node.label}
              path={node.path}
            />
          ))}
        </StyledBox>
        <UserMenuTsoPq />
      </StyledToolbar>
    </StyledNavBar>
  );
};
export default NavbarTsoPq;
